import { useCallback, useEffect, useState, createRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import EmojiReactions from 'components/EmojiReactions'

const GridItem = ({
  tenant,
  colorMode,
  title,
  short,
  person,
  image,
  caption,
  text,
  id,
  index,
  setIsStoryOpen,
  setActiveStory,
  setAnimationPlayed,
  articleId,
}: {
  tenant?: object
  colorMode?: string
  title?: string
  short?: string
  person?: string
  image?: string
  caption?: string
  text: string
  id: string
  index: number
  setIsStoryOpen: any
  setActiveStory: any
  setAnimationPlayed: any
  articleId: string
}) => {
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  const openStory = (index: number) => {
    setIsStoryOpen(true)
    setActiveStory(index)

    document.body.style.overflow = 'hidden'
    document.body.style.height = '100%'
    const fcElement = document.querySelector('[class*=FrontendComponent_root]')
    console.log('fcElement', fcElement)
    if (fcElement) {
      ;(fcElement as HTMLElement).style.zIndex = '400'
    }

    setTimeout(() => {
      setAnimationPlayed(true)
    }, 300)
  }

  return (
    <Griditem
      className={isMobile ? 'mobile' : 'desktop'}
      onClick={() => openStory(index)}
    >
      <div className='photo'>
        <div className='wrapper'>
          <img
            src={
              'https://storage.googleapis.com/ta-interaktiv/trennungsgeschichten/images/' +
              image
            }
            alt='foto'
          />
        </div>
      </div>
      <div className='person'>{person}</div>
      <h3>{title}</h3>
      <div className='short'>{short}</div>
      <div className='foot'>
        <div className='more'>mehr lesen</div>
        <EmojiReactions
          isDisplayOnly={true}
          storyId={
            title
              ? title
                  .replace(/\s/g, '')
                  .replace('«', '')
                  .replace('»', '')
                  .toLowerCase()
              : 'unknown'
          }
          articleId={articleId}
        />
      </div>

      {/* <div className='text' dangerouslySetInnerHTML={{ __html: text }} /> */}
    </Griditem>
  )
}
const Griditem = styled.div`
  color: var(--text-color);
  padding-bottom: 2rem;
  border-bottom: 1px solid #d4d4d4;
  overflow: hidden;
  cursor: pointer;

  .person {
    font-size: 2rem;
    @media only screen and (max-width: 600px) {
      font-size: 1.9rem;
      line-height: 2.2rem;
      margin-bottom: 0.8rem;
    }
    color: var(--red-accent);
  }
  h3 {
    padding-bottom: 0.6rem;
    margin: 0.4rem 0 0.2rem;
    font-size: 2.2rem;
    line-height: 2.8rem;
    font-weight: 800;
  }
  .short {
    font-size: 1.7rem;
    line-height: 2.7rem;
  }

  .photo {
    .wrapper {
      overflow: hidden;
    }
    img {
      display: block;
      width: 100%;
      height: auto;
      transition: transform 200ms ease-in;
    }
    margin-bottom: 1rem;
  }
  &:hover {
    .photo {
      .wrapper {
        img {
          transform: scale(1.04);
        }
      }
    }
    .foot .more {
      text-decoration: none;
    }
  }
  .caption {
    color: var(--gray-3);
    font-size: 1.4rem;
    line-height: 2rem;
    margin-top: 0.3rem;
    margin-bottom: 0;
  }
  .foot {
    margin-top: 1.5rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 0;
    position: relative;
    .more {
      color: var(--red-accent);
      text-decoration: underline;
      font-weight: 600;
    }
  }
  .text {
    font-family: var(--font-serif);
    a:hover,
    a:link,
    a:active,
    a:visited {
      background-image: linear-gradient(90deg, #ffe462, #ffe462);
      background-repeat: repeat-x;
      background-position: bottom;
      background-size: 100% 20%;
      transition: all 0.1s ease-in-out;
      color: var(--text-color);
      background-origin: content-box;
      text-decoration: none;
    }
    a:hover {
      background-size: 100% 100%;
      color: var(--brandblue-main);
    }
  }
`

export default GridItem
